var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[(_vm.department)?_c('ui-header',{attrs:{"heading":_vm.$tc('misc.overview', 2)}}):_vm._e(),(_vm.department)?_c('department-courses',{attrs:{"department":_vm.department}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }